/* unplugin-vue-components disabled */import { render } from "./WatchVideo.vue?vue&type=template&id=0c630a18&scoped=true"
import script from "./WatchVideo.vue?vue&type=script&lang=js"
export * from "./WatchVideo.vue?vue&type=script&lang=js"

import "./WatchVideo.vue?vue&type=style&index=0&id=0c630a18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c630a18"]])

export default __exports__